import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ViewController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the MyaccountPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-myaccount',
  templateUrl: 'myaccount.html',
})
export class MyaccountPage {

  	loginId: string;
  	api_key: string;
  	version: string;
	params1: any;

	texts: any = [];
    language : string;

	email: string;
	coin_unit: string;
	coin_list: any
	
	id: string;
	name: string;
	date: string;
	phone: string;
	country: string;
	center: string;
	chucheon: string;
	huwon: string;
	chucheon_active: string ='N';
	coin_address: string;
	
	is_enabled_btn_download: boolean = true;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams, 
		public alertCtrl: AlertController,
		private http: HttpService,
		public viewCtrl: ViewController,
		public app: App
	) {
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}
		// 페이지 이름
		localStorage.setItem("pageName", "myaccount");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");

        this._get_texts();
		
		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).myaccount;
	}    

	_save() {
		let send_data = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version,
			name: this.name,
			phone: this.phone, 
			country: this.country
        });
        this.http.post("user/info/index/save", send_data).then((res: any) => {
            if(res.result == "OK") {						
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
				alert.present();
				                
            } else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                
                //// 에러메시지를 받았을때 표시한다.
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();                    
            }
        
        }, err => {
            
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        
        });
        return ;
			
	}

	_init() {
		let send_data = JSON.stringify({
			api: this.api_key,
			language: this.language,
			version: this.version,
		});
		this.http.post("user/info", send_data).then((res: any) => {
            if(res.result == "OK") {
                this.id = res.id;
                this.name = res.name;
                this.phone = res.phone;
                this.country = res.country;
                this.chucheon = res.chucheon;
                this.huwon = res.huwon;
				this.params1 = res.country_list;
				
            } else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        }, err => {
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        });
	}

	_close() {
		this.navCtrl.pop();
	}
}



// WEBPACK FOOTER //
// ./src/pages/myaccount/myaccount.ts